import axios from "axios";

const lideres = {
  state: () => ({
    lideres: [],
    lider: {},
    lideresCategoria: [],
    expertosRegionales: [],
    lideresCampesena: [],
    liderCampesena:{},
  }),

  getters: {
    obtenerLideres(state) {
      return state.lideres;
    },

    obtenerLider(state) {
      return state.lider;
    },

    obtenerLideresCategoria(state) {
      return state.lideresCategoria;
    },

    obtenerLideresCampesena(state) {
      return state.lideresCampesena;
    },
    obtenerLiderCampesena(state) {
      return state.liderCampesena;
    },
  },

  mutations: {
    enviarLideres(state, lideres) {
      state.lideres = lideres;
    },

    enviarLider(state, lider) {
      state.lider = lider;
    },

    enviarLideresCategoria(state, lideresCategoria) {
      state.lideresCategoria = lideresCategoria;
    },

    enviarExpertosRegionales(state, expertosRegionales) {
      state.expertosRegionales = expertosRegionales;
    },
    enviarLideresCampesena(state, lideresCampesena) {
      state.lideresCampesena = lideresCampesena;
    },
    enviarLiderCampesena(state, liderCampesena) {
      state.liderCampesena = liderCampesena;
    },
  },

  actions: {
    registrarLider(context, lider) {
      return new Promise((resolve, reject) => {
        axios.post("api/lideres", lider)
        .then((response) => resolve(response.data))
        .catch(() => reject());
      });
    },

    gestionarLideres(context, competencia) {
      axios.get("api/competencias/"+competencia+"/lideres")
        .then((response) => {
          const lideres = [];

          response.data.results.forEach((lider) => {
            lideres.push({
              id:               lider.id_lider,
              competencia:      lider.competencia.competencia,
              categoria:        lider.categoria.categoria,
              tipo_lider:       lider.tipo_lider.tipo_lider,
              centro_formacion: lider.centro_formacion.centro_formacion,
              regional:         lider.centro_formacion.regional.regional,
              identificacion:   lider.persona.identificacion,
              nombres:          lider.persona.primer_nombre+" "+lider.persona.segundo_nombre,
              apellidos:        lider.persona.primer_apellido+" "+lider.persona.segundo_apellido,
            });
          });

          context.commit("enviarLideres", lideres);
        })
        .catch(() => {});
    },

    detallesLider(context, id) {
      axios.get("api/lideres/"+id)
        .then((response) => {
          const detalles = response.data.results;

          const lider = {
            competencia:            detalles.competencia.competencia,
            categoria_id:           detalles.categoria_id,
            categoria:              detalles.categoria.categoria,
            tipo_lider_id:          detalles.tipo_lider_id,
            tipo_lider:             detalles.tipo_lider.tipo_lider,
            regional_id:            detalles.centro_formacion.regional_id,
            regional:               detalles.centro_formacion.regional.regional,
            centro_formacion_id:    detalles.centro_formacion_id,
            persona_id:             detalles.persona.id_persona,
            centro_formacion:       detalles.centro_formacion.centro_formacion,
            tipo_identificacion_id: detalles.persona.tipo_identificacion_id,
            tipo_identificacion:    detalles.persona.tipo_identificacion.tipo_identificacion,
            identificacion:         detalles.persona.identificacion,
            nombres:                detalles.persona.primer_nombre+" "+detalles.persona.segundo_nombre,
            apellidos:              detalles.persona.primer_apellido+" "+detalles.persona.segundo_apellido,
            telefono_movil:         detalles.persona.telefono_movil,
            correo:                 detalles.persona.correo,
            direccion:              detalles.persona.direccion,
            fecha_nacimiento:       detalles.persona.fecha_nacimiento,
            genero_id:              detalles.persona.genero_id,
            genero:                 detalles.persona.genero.genero,
            estado_civil_id:        detalles.persona.estado_civil_id,
            estrato:                detalles.persona.estrato,
            zona_id:                detalles.persona.zona_id,
            discapacidad_id:        detalles.persona.discapacidad_id,
            talla_camiseta:         detalles.talla_camiseta,
          };
          
          context.commit("enviarLider", lider);
        })
        .catch(() => {});
    },

    actualizarLider(context, lider) {
      return new Promise((resolve, reject) => {
        axios.put("api/lideres/"+lider.id, lider)
        .then((response) => resolve(response.data))
        .catch(() => reject());
      });
    },

    eliminarLider(context, id) {
      return new Promise((resolve, reject) => {
        axios.delete("api/lideres/"+id)
        .then((response) => resolve(response.data))
        .catch(() => reject());
      });
    },

    importarLideres(context, lideres) {
      return new Promise((resolve, reject) => {
        axios.post("api/importar/lideres", lideres, { headers: { "Content-Type": "multipart/form-data" } })
        .then((response) => resolve(response.data))
        .catch(() => reject());
      });
    },

    descargarPlantillaLideres() {
      return new Promise((resolve, reject) => {
        axios.get("api/documento/lideres", { responseType: "blob" })
        .then((response) => resolve(response))
        .catch(() => reject());
      });
    },

    // revisar
    gestionarLideresCategoria(context, categoria) {
      axios.get("api/lideres/categoria/"+categoria.competencia_id+"/" +categoria.centro_formacion_id)
      .then((response) => {
        const lideresCategoria = [];
        for (let i = 0; i < response.data.results.length; i++) {
          lideresCategoria.push({
            indice: i + 1,
            competencia_id:
              response.data.results[i].competencia.id_competencia,
            competencia: response.data.results[i].competencia.competencia,
            categoria_id: response.data.results[i].categoria.id_categoria,
            categoria: response.data.results[i].categoria.categoria,
            tipo_lider_id: response.data.results[i].tipo_lider.id_tipo_lider,
            tipo_lider: response.data.results[i].tipo_lider.tipo_lider,
            centro_formacion_id:
              response.data.results[i].centro_formacion.id_centro_formacion,
            centro_formacion:
              response.data.results[i].centro_formacion.centro_formacion,
            persona_id: response.data.results[i].persona.id_persona,
            nombres:
              response.data.results[i].persona.primer_nombre +
              " " +
              response.data.results[i].persona.segundo_nombre,
            apellidos:
              response.data.results[i].persona.primer_apellido +
              " " +
              response.data.results[i].persona.segundo_apellido,
            telefono_movil: response.data.results[i].persona.telefono_movil,
            id_lider: response.data.results[i].id_lider,
          });
        }
        context.commit("enviarLideresCategoria", lideresCategoria);
      })
      .catch(() => {});
    },

    gestionarExpertoHabilad(context, categoria) {
      axios.get("api/competencias/"+categoria.competencia_id+"/lideres/"+categoria.centro_formacion_id)
      .then((response) => {
        const lideresCategoria = [];
        for (let i = 0; i < response.data.results.length; i++) {
          lideresCategoria.push({
            indice: i + 1,
            competencia_id:
              response.data.results[i].competencia.id_competencia,
            competencia: response.data.results[i].competencia.competencia,
            categoria_id: response.data.results[i].categoria.id_categoria,
            categoria: response.data.results[i].categoria.categoria,
            tipo_lider_id: response.data.results[i].tipo_lider.id_tipo_lider,
            tipo_lider: response.data.results[i].tipo_lider.tipo_lider,
            centro_formacion_id:
              response.data.results[i].centro_formacion.id_centro_formacion,
            centro_formacion:
              response.data.results[i].centro_formacion.centro_formacion,
            persona_id: response.data.results[i].persona.id_persona,
            nombres:
              response.data.results[i].persona.primer_nombre +
                " " +
                response.data.results[i].persona.segundo_nombre ==
              "null"
                ? response.data.results[i].persona.primer_nombre +
                  " " +
                  response.data.results[i].persona.segundo_nombre
                : response.data.results[i].persona.primer_nombre,
            apellidos:
              response.data.results[i].persona.primer_apellido +
                " " +
                response.data.results[i].persona.segundo_apellido ==
              "null"
                ? response.data.persona.primer_apellido +
                  " " +
                  response.data.results[i].persona.segundo_apellido
                : response.data.results[i].persona.primer_apellido,
            correo: response.data.results[i].persona.correo,
            telefono_movil: response.data.results[i].persona.telefono_movil,
          });
        }
        context.commit("enviarLideresCategoria", lideresCategoria);
      })
      .catch(() => {});
    },

    gestionarExpertoCompetencia(context, categoria) {
      axios.get("api/competencias/"+categoria.competencia_id+"/lideres/"+categoria.centro_formacion_id)
      .then((response) => {
        const lideresCategoria = [];
        for (let i = 0; i < response.data.results.length; i++) {
          lideresCategoria.push({
            indice: i + 1,
            competencia_id: response.data.results[i].competencia.id_competencia,
            competencia: response.data.results[i].competencia.competencia,
            categoria_id: response.data.results[i].categoria.id_categoria,
            categoria: response.data.results[i].categoria.categoria,
            tipo_lider_id: response.data.results[i].tipo_lider.id_tipo_lider,
            tipo_lider: response.data.results[i].tipo_lider.tipo_lider,
            centro_formacion_id:
              response.data.results[i].centro_formacion.id_centro_formacion,
            centro_formacion:
              response.data.results[i].centro_formacion.centro_formacion,
            persona_id: response.data.results[i].persona.id_persona,
            nombres:
              response.data.results[i].persona.primer_nombre +
                " " +
                response.data.results[i].persona.segundo_nombre ==
              "null"
                ? response.data.results[i].persona.primer_nombre +
                  " " +
                  response.data.results[i].persona.segundo_nombre
                : response.data.results[i].persona.primer_nombre,
            apellidos:
              response.data.results[i].persona.primer_apellido +
                " " +
                response.data.results[i].persona.segundo_apellido ==
              "null"
                ? response.data.persona.primer_apellido +
                  " " +
                  response.data.results[i].persona.segundo_apellido
                : response.data.results[i].persona.primer_apellido,
            correo: response.data.results[i].persona.correo,
            telefono_movil: response.data.results[i].persona.telefono_movil,
          });
        }
        context.commit("enviarLideresCategoria", lideresCategoria);
      })
      .catch(() => {});
    },


    //lideres campesena 
    gestionarlideresCampesena(context, idCompetencia) {
      axios.get(`/api/campesena/competencias/${idCompetencia}/lideres`)
        .then((response) => {
          const lideres = [];
          response.data.results.forEach((lider) => {
            lideres.push({
              id: lider.id_lider,
              persona_id: lider.persona.persona_id,
              identificacion: lider.persona.identificacion,
              nombres: `${lider.persona.primer_nombre} ${lider.persona.segundo_nombre}`,
              apellidos: `${lider.persona.primer_apellido} ${lider.persona.segundo_apellido}`,
              correo: lider.persona.correo,
              centro_formacion: lider.centro_formacion.centro_formacion,
    
            });
          });
          context.commit("enviarLideresCampesena", lideres);
        })
        .catch(() => {});
    },
    registrarLideresCampesena(context, lider) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/campesena/lideres`, lider)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
      });
    },
    eliminarLiderCampesena(context, idLider) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/campesena/lideres/${idLider}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch(() => {
                reject()
            })
        })
    },
    obtenerCampesenaLiderId(context, idLider) {
      axios.get(`/api/campesena/lideres/${idLider}`)
        .then((response) => {
    
          const r = response.data.results;
                 
          const lider = {
            id: r.id_lider,
            competencia_id: r.competencia_id,
            saber_id :r.saber_id,
            saber: r.saber.saber,
            categoria_id: r.saber.categoria.id_categoria,
            categoria: r.saber.categoria.categoria,
            centro_formacion_id: r.centro_formacion_id,
            persona_id: r.persona_id,
            talla_camiseta: r.talla_camiseta,
            competencia: r.competencia.competencia,        
            tipo_lider_id: r.tipo_lider_id,
            tipo_lider: r.tipo_lider.tipo_lider,
            centro_formacion: r.centro_formacion.centro_formacion,
            tipo_identificacion : r.persona.tipo_identificacion.id_tipo_identificacion,
            identificacion: r.persona.identificacion,
            nombres: `${r.persona.primer_nombre} ${r.persona.segundo_nombre}`,
            apellidos: `${r.persona.primer_apellido} ${r.persona.segundo_apellido}`,
            correo: r.persona.correo,
            telefono_movil: r.persona.telefono_movil,
            direccion: r.persona.direccion,
            fecha_nacimiento: r.persona.fecha_nacimiento,
            genero_id: r.persona.genero.id_genero,
            genero: r.persona.genero.genero,
            estado_civil: r.persona.estado_civil_id,
            estrato: r.persona.estrato,
            zona: r.persona.zona_id,
            discapacidad: r.persona.discapacidad_id,
            regional_id: r.centro_formacion.regional.id_regional,
            restriccion_alimentaria: r.persona.restriccion_alimentaria,
            descripcion_restriccion_alimentaria: r.persona.descripcion_restriccion_alimentaria,
            enfermedad_existente:r.persona.enfermedad_existente,
            descripcion_enfermedad_existente: r.persona.descripcion_enfermedad_existente,
            tipo_alimentacion_id: r.persona.tipo_alimentacion_id
    
          };    
          context.commit("enviarLiderCampesena", lider);
        })
        .catch(() => {});
    },
    actualizarliderCampesena(context, {liderId, lider}) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/campesena/lideres/${liderId}`, lider)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },
    
  },
};

export default lideres;
